import { CSSProperties, PropsWithChildren, ReactElement } from 'react'

import { Checkbox, type CheckboxProps } from 'antd'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikCheckboxProps<V> = PropsWithChildren<
    FormikWithCustomHandlersProps<V> & {
        style?: CSSProperties
        disabled?: boolean
    } & CheckboxProps
>

function FormikCheckbox<V extends boolean>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikCheckboxProps<V>): ReactElement {
    return (
        <Checkbox
            checked={value}
            onChange={(e) => handleChange(e.target.checked)}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikCheckbox)
